import axios from 'axios';
import cfg from '../../config.json';
import { getDeviceId, getDeviceMeta, getSessionId } from '../store/fingerprint';
export const $axiosL = axios.create();

$axiosL.defaults.timeout = 60000;

// Interceptor when requesting http
$axiosL.interceptors.request.use(async (config) => {
    document.querySelector('.spinner-box').classList.add('show');
    config.headers.Credentials = 'dirineo';
    if (cfg.request_timeout > 0) {
        config.timeout = cfg.request_timeout * 1000; // in seconds
    }

    try {
        const deviceId = await getDeviceId();
        const sessionId = getSessionId();
        const meta = getDeviceMeta()

        const clientContext = {
            deviceId,
            sessionId,
            meta,
            ts: Date.now()
        };
        const encoded = btoa(JSON.stringify(clientContext))
        config.headers['x-client-context'] = encoded;
    } catch (err) {
        console.error('Fingerprint error:', err);
    }

    return config;
});

//Interceptor after response

$axiosL.interceptors.response.use(function (response) {
    document.querySelector('.spinner-box').classList.remove('show');
    return response;
}, function (error) {
    document.querySelector('.spinner-box').classList.remove('show');
    return Promise.reject(error)
}
);

//Interceptor after request error